<template>
  <div>
    <Filters
      :filters="sectorsAssociationFilters"
      filter-key="sectorsAssociation"
      :initial-data="filtersStatus.sectorsAssociation"
      :loading="filtersLoading"
    />

    <ViewActionButtons :buttons="actionButtons" />

    <TableWrapper
      :table-columns="sectorsAssociationColumns"
      table-key="sectorsAssociation"
      row-key="tableId"
      @editSector="openEditModal"
      @deleteSector="deleteSector"
    />

    <CreateEditSector
      v-if="openCreateEditSector"
      :is-modal-edit="isModalEdit"
      :initial-data="initialSectorData"
      @dialogClose="handleDialogClose"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import {
    sectorsAssociationFilters,
    sectorsAssociationColumns,
  } from '@/config';
  import { sectorsAssociationApi } from '@/api';
  import Filters from '@/components/Filters.vue';
  import TableWrapper from '@/components/TableWrapper.vue';
  import ViewActionButtons from '@/components/ViewActionButtons.vue';
  import abortControllerMixin from '@/mixins/abortControllerMixin';
  import filterLoadingMixin from '@/mixins/filterLoadingMixin';
  import axios from 'axios';

  import CreateEditSector from './CreateEditSector.vue';

  export default {
    name: 'SectorsAssociationIndex',
    components: {
      Filters,
      TableWrapper,
      ViewActionButtons,
      CreateEditSector,
    },
    mixins: [abortControllerMixin, filterLoadingMixin],
    data() {
      return {
        sectorsAssociationFilters,
        sectorsAssociationColumns,
        actionButtons: [
          {
            text: this.$t('sectorsAssociation.createSector'),
            type: 'primary',
            permissions: ['locationSectorDepartmentManage'],
            action: () => {
              this.openCreateEditSector = true;
            },
          },
        ],
        openCreateEditSector: false,
        isModalEdit: false,
        initialSectorData: {},
      };
    },
    computed: {
      ...mapGetters(['tableFilters', 'filtersStatus']),
    },
    methods: {
      ...mapActions([
        'updateTableRows',
        'updateTableCount',
        'parseQueryStringStatus',
      ]),
      async tableRows() {
        const signal = this.createAbortController();
        this.filtersLoading = true;
        let aborted = false;
        try {
          const sectorsAssociationIndex = await sectorsAssociationApi.index(
            this.tableFilters('sectorsAssociation'),
            this.filtersStatus.sectorsAssociation,
            { signal }
          );
          const sectorsAssociationCount = await sectorsAssociationApi.count(
            this.filtersStatus.sectorsAssociation,
            { signal }
          );
          this.updateTableRows({
            tableKey: 'sectorsAssociation',
            rows: sectorsAssociationIndex.data,
          });
          this.updateTableCount({
            tableKey: 'sectorsAssociation',
            count: sectorsAssociationCount.data.count,
          });
        } catch (error) {
          if (axios.isCancel(error)) {
            aborted = true;
            return;
          }
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        } finally {
          if (!aborted) {
            this.filtersLoading = false;
          }
        }
      },
      openEditModal(row) {
        this.initialSectorData = row;
        this.isModalEdit = true;
        this.openCreateEditSector = true;
      },
      deleteSector(row) {
        this.$confirm(
          this.$t('global.confirmAction'),
          this.$t('global.warning'),
          {
            confirmButtonText: this.$t('global.confirm'),
            cancelButtonText: this.$t('global.cancel'),
          }
        ).then(async () => {
          await sectorsAssociationApi.delete(row.id);
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('locationsManagement.create.success'),
          });
          this.tableRows();
        });
      },
      handleDialogClose(status) {
        this.openCreateEditSector = false;
        if (this.isModalEdit) this.isModalEdit = false;
        if (status.success) this.tableRows();
      },
    },
    created() {
      this.parseQueryStringStatus(this.$route.query);
      this.tableRows();
    },
    beforeRouteUpdate(to, from, next) {
      this.parseQueryStringStatus(to.query);
      this.tableRows();
      next();
    },
  };
</script>
